<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form class="app-pay-form" v-if="transaction_id == 0" @submit.prevent="send" style="min-height:100px">
          <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;margin-bottom: 50px;' : ''" />
          <slot v-if="!loading">
            <slot name="content"></slot>
            <div class="col">
              <div class="inline-form">
                <label>Tutar</label>
                <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
              </div>
            </div>
            <div class="col" v-show="form.currency != null">
              <div class="inline-form">
                <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Yatır'" />
              </div>
            </div>
            <div class="col">
              <div class="inline-form">
                <label>Coin Seçiniz</label>
                <ul class="list-payments coins">
                  <li v-for="(provider, name) in coins" :key="name" v-on:click="form.currency = name" :class="form.currency == name ? 'active' : ''">
                    <a href="javascript:;">
                      <div class="media">
                        <img class="icon" :class="name" :src="$store.state.main.cdn_url + '/providers/coins/'+ name +'.png'">
                      </div>
                      <div class="info">
                        <div class="item">{{ provider }}</div>
                        <div class="decription text-capitalize">{{ name }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </slot>
      </form>
      <form class="app-pay-form" v-else>
				<div class="btc-payment-details">
					<div class="col" style="flex-direction:column">
						<div class="info">Gerekli onay sayısı: <span v-html="detail.confirms_needed"></span> </div>
						<div class="info">Hesaba geçecek tutar: <span v-html="detail.amount2 + ' ' + user.currency"></span> </div>
						<div class="info">Tutar: <span v-html="detail.amount1 + ' ' + form.currency"></span> </div>
						<div class="info">Durum: <span v-html="detail.status"></span> </div>
						<div class="info">Ödeme ID: <span v-html="detail.transaction_id"></span> </div>
						<div class="info">Gönderilecek Adres: <span v-html="detail.address"></span> </div>
					</div>
					<div class="col">
						<img width="200" class="qr-image" :src="detail.qrcode">
					</div>
					<div class="col">
						<div class="row">
              <br>
							<div class="col" :style="isMobile ? 'margin-top:5px' : ''">
								<ButtonLoader @click.native="cancelTransaction" :type="'button'" class="primary danger block" :loader="btnLoading" :text="'İptal Et'" />
							</div>
						</div>
					</div>
				</div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props:['providerInfo'],
    data(){
      return{
        form: {
          currency: null,
          amount: 0,
        },
        detail: {
          amount1:0,
          amount2:0,
          status:null,
          transaction_id:null,
          address:null,
          qrcode:null,
          confirms_needed:0,
        },
        coins:[],
        loading:false,
        btnLoading: false,
        cancelBtnLoading: false,
        transaction_id:0,
      }
    },
    computed:{
      user(){
        return this.$user();
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData() {
        this.loading = true;
        axios.get('/user/wallet/deposit/crypto/coin_list')
        .then((response) => {
          this.coins = response.data.list;
        })
        .catch((err) => {
        })
        .finally(() => {
        });
        axios.get('/user/wallet/crypto/detail')
        .then((response) => {
          if (response.data.status) {
            this.transaction_id 		= response.data.transaction.id;
            this.detail.amount1 		= response.data.detail.amount;
            this.detail.amount2 		= response.data.transaction.amount;
            this.detail.status 			= response.data.transaction.status_name;
            this.detail.transaction_id 	= response.data.transaction.id;
            this.detail.address 		= response.data.detail.address;
            this.detail.qrcode 			= response.data.detail.qrcode_url;
            this.detail.confirms_needed = response.data.detail.confirms_needed;
            this.form.currency 			= response.data.detail.coin;
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loading = false;
        });
      },
      fetchTransactionData(){
        axios.get('/user/wallet/transaction/' + this.transaction_id + '/detail')
        .then((response) => {
          if (response.data.status) {
            this.detail.amount1 		= response.data.detail.amount;
            this.detail.amount2 		= response.data.transaction.amount;
            this.detail.status 			= response.data.transaction.status_name;
            this.detail.transaction_id 	= response.data.transaction.id;
            this.detail.address 		= response.data.detail.address;
            this.detail.qrcode 			= response.data.detail.qrcode_url;
            this.detail.confirms_needed = response.data.detail.confirms_needed;
            this.form.currency 			= response.data.detail.coin;
          }
        })
        .catch(() => {
        })
      },
      clearData(){
        this.form 				= {currency: 'TRY', amount: 0, depositCurrency: null};
        this.detail 			= {amount:0, status:null, transaction_id:null, address:null};
        this.transaction_id 	= 0;
      },
      cancelTransaction(){
        if (this.transaction_id > 0) {
            this.cancelBtnLoading  = true;
            axios.patch('/user/wallet/deposit/crypto/cancel', {transaction_id: this.transaction_id})
            .then((response) => {
              if (response.data.status) {
                this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
                this.clearData();
              }
            })
            .catch((err) => {
            })
            .finally(() => {
              this.cancelBtnLoading  = true;
            });
        };
      },
      send(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/deposit/crypto/create', this.form)
        .then((response) => {
          if (response.data.status) {
              this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
              this.detail.amount2 		= this.form.amount;
              this.detail.amount1 		= response.data.result.amount;
              this.detail.status 			= response.data.result.status;
              this.detail.transaction_id 	= response.data.result.transaction_id;
              this.detail.address 		= response.data.result.address;
              this.detail.qrcode 			= response.data.result.qrcode_url;
              this.detail.confirms_needed = response.data.result.confirms_needed;
              this.transaction_id  		= response.data.transaction_id;
              console.log(this.detail, this.transaction_id);
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      }
    },
    components:{
      Header,
      Form
    }
  }

</script>